import React, { FC } from 'react';
import { Element } from 'react-scroll';

import { useMediaQuery } from '../../../../contexts/MediaQueryContext';
import { RegionsListItem } from '../ProposalPage';
import { DynamicTableRegion } from './DynamicTableRegion';

const regionNamesMap: { [key: string]: string } = {
  'Southeast Asia': 'SEA',
  'EU': 'Europe',
  'LATAM': 'Latam',
  'International CC & Global Solutions': 'CC'
};

interface DynamicTableProps {
  regions: RegionsListItem[];
}

const DynamicTable: FC<DynamicTableProps> = ({ regions }): JSX.Element => {
  const { onMobile } = useMediaQuery();

  return (
    <Element name='scroll-wrapper' id='scroll-wrapper' className='proposal-info scroll-div'>
      {regions
        .filter((r) => r.selected && r.name)
        .map((region) => (
          <Element
            key={`${region.name}-pricing`}
            name={region.name}
            id={region.name}
            className='proposal-box'
          >
            {onMobile
              ? (<div className='proposal-title-box-mobile'>
                  <img src={`${process.env.PUBLIC_URL}/assets/images/${region.icon}.png`} alt=""/>
                  <div className='proposal-title'>{region.name}</div>
                </div>)
              : (<div className='proposal-title'>
                  {region.name}
                </div>)
            }

            <div className='dynamic-table'>
              <DynamicTableRegion region={regionNamesMap[region.name] || region.name}/>
            </div>
          </Element>
        ))}
    </Element>
  );
};

export default DynamicTable;